
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeakerOff as ObiSpeakerOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speaker-off.js';
 
 
 

 
 export const ObiSpeakerOff = createComponent({
   react: React,
   tagName: 'obi-speaker-off',
   elementClass: ObiSpeakerOffElement,
   events: {
     
   }
  });
 
 